import HttpService from "../../SharedModule/utils/api";
import { UserProjectsWorkOrders } from "../../SharedModule/types/shared-module-types";
import {
  FiltersToApproveBody,
  FiltersWhoIsOutBody,
  TimeConfirmationInfoBody,
  TimeEntryEditForm,
} from "../types/times-module-types";

const BASE_URL = "/timesheets";

function getWeeklyHours(): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/timeentries/weekly-hours`,
    data: {
      TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
}

function getTaskTypes(): Promise<any> {
  return HttpService.req(`${BASE_URL}/TaskTypes`);
}

function getNonBillableReasons(): Promise<any> {
  return HttpService.req(`${BASE_URL}/NonBillableReasons`);
}

function getTimesEntries(
  userId: string,
  startDate: string,
  endDate: string
): Promise<any> {
  return HttpService.req({
    method: "get",
    url: `${BASE_URL}/timeentries/${userId}/${startDate}/${endDate}`,
    hasOwnHandler: true,
  });
}

function getTimeEntriesSummary(
  userId: string,
  startDate: string,
  endDate: string
): Promise<any> {
  return HttpService.req({
    method: "get",
    url: `${BASE_URL}/timeentries/${userId}/${startDate}/${endDate}/summary`,
    hasOwnHandler: true,
  });
}

function getUserHolidays(
  userId: string,
  startDate: string,
  endDate: string
): Promise<any> {
  return HttpService.req({
    method: "get",
    url: `${BASE_URL}/timeentries/${userId}/holidays?startDate=${startDate}&endDate=${endDate}`,
    hasOwnHandler: true,
  });
}

function addTimesEntries(body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/timeentries`,
    data: [...body],
    hasOwnHandler: true,
  });
}

function editTimesEntry(body: TimeEntryEditForm, id: number): Promise<any> {
  return HttpService.req({
    method: "put",
    url: `${BASE_URL}/timeentries/${id}`,
    data: { ...body },
    hasOwnHandler: true,
  });
}

function deleteTimesEntry(id: number): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/timeentries/${id}/delete`,
    hasOwnHandler: true,
  });
}

function getTimeEntryInfo(id: number): Promise<any> {
  return HttpService.req({
    methos: "get",
    url: `${BASE_URL}/Audit/time-entries/${id}`,
    hasOwnHandler: true,
  });
}

function getQueryFilters(): Promise<any> {
  return HttpService.req({
    methos: "get",
    url: `${BASE_URL}/query/filters`,
    hasOwnHandler: true,
  });
}

function getUserProjects(id: string): Promise<UserProjectsWorkOrders> {
  return HttpService.req(`${BASE_URL}/users/${id}/projects`);
}

function getQueryResults(body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/query`,
    data: { ...body },
    hasOwnHandler: true,
  });
}

function updateTimeEntries(body: any): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/timeentries/update`,
    data: { ...body },
    hasOwnHandler: true,
  });
}

function unlockTimeEntries(body: any): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/timeentries/unlock`,
    data: { ...body },
    hasOwnHandler: true,
  });
}

function getApprovalTimeFilters(): Promise<any> {
  return HttpService.req({
    url: `${BASE_URL}/query/approve-filters`,
    hasOwnHandler: true,
  });
}

function getProjectsByUsers(body: string[]): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/users/common-projects`,
    data: [...body],
  });
}

function getTimeEntriesToApproveByUsers(
  body: FiltersToApproveBody
): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/query/to-approve`,
    data: { ...body },
  });
}

function getTimeEntriesToApproveByUser(body: number[]): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/timeentries/list-view`,
    data: [...body],
  });
}

function getPayPeriods(): Promise<any> {
  return HttpService.req({
    url: `${BASE_URL}/payperiods/current`,
    hasOwnHandler: true,
  });
}

function getYearPayPeriods(): Promise<any> {
  return HttpService.req({
    url: `${BASE_URL}/payperiods/year`,
    hasOwnHandler: true,
  });
}

function getTimeConfirmationFilters(): Promise<any> {
  return HttpService.req(`${BASE_URL}/reports/time-confirmation/filters`);
}

function getTimeConfirmationInfo(body: TimeConfirmationInfoBody): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/reports/time-confirmation`,
    data: { ...body },
  });
}

function getWhoisOutInfo(body: FiltersWhoIsOutBody): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/reports/who-is-out`,
    data: { ...body },
  });
}

function getOwnMissingTime(): Promise<any> {
  return HttpService.req(`${BASE_URL}/users/missing-time`);
}

function getWhoisOutFilters(): Promise<any> {
  return HttpService.req({
    url: `${BASE_URL}/reports/who-is-out/filters`,
    hasOwnHandler: true,
  });
}

function getMealBreakReportInfo(
  startDate: string,
  endDate: string
): Promise<any> {
  return HttpService.req(
    `${BASE_URL}/reports/meal-break/${startDate}/${endDate}`
  );
}

function getMissingTime(email: string): Promise<any> {
  return HttpService.req(`${BASE_URL}/users/${email}/missing-time`);
}

function getMealBreakReminderInfo(email: string): Promise<any> {
  return HttpService.req(`${BASE_URL}/users/${email}/missing-meal-break-time`);
}

function getPriceExceptionsByClient(id: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/ExceptionRates/client/${id}`);
}

function getTimeEntriesUsSalaried(): Promise<any> {
  return HttpService.req(
    `${BASE_URL}/uspayrollreports/uspayrollexportsalaried`
  );
}

function getTimeEntriesUsHourly(): Promise<any> {
  return HttpService.req(`${BASE_URL}/uspayrollreports/uspayrollexporthourly`);
}

export const TimesheetsService = {
  getWeeklyHours,
  getTaskTypes,
  getNonBillableReasons,
  getTimesEntries,
  getTimeEntriesSummary,
  getUserHolidays,
  addTimesEntries,
  editTimesEntry,
  deleteTimesEntry,
  getTimeEntryInfo,
  getQueryFilters,
  getUserProjects,
  getQueryResults,
  updateTimeEntries,
  unlockTimeEntries,
  getApprovalTimeFilters,
  getProjectsByUsers,
  getTimeEntriesToApproveByUsers,
  getTimeEntriesToApproveByUser,
  getPayPeriods,
  getYearPayPeriods,
  getTimeConfirmationFilters,
  getTimeConfirmationInfo,
  getWhoisOutInfo,
  getOwnMissingTime,
  getMealBreakReportInfo,
  getWhoisOutFilters,
  getMissingTime,
  getMealBreakReminderInfo,
  getPriceExceptionsByClient,
  getTimeEntriesUsSalaried,
  getTimeEntriesUsHourly,
};
